<script setup lang="ts">
import DisplayDeliveryPlanInformation from '@/components/DailyReportEdit/Split/DisplayDeliveryPlanInformation.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';

const props = defineProps<{
  deliveryPlan: getDeliveryPlanVehicleInformation
  splitReturningAndLeavingTime: {
    splitReturningTime: string | null;
    splitLeavingTime: string | null;
  }
}>();

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}
</script>
<template>
  <div class="w-100 my-6">
    <v-row>
      <div class="w-100 d-flex justify-center">
        <h5>{{ i18n.global.t('pages.dailyReports.splitConfirmModal.body') }}</h5>
      </div>
    </v-row>
    <v-row class="mt-2 mb-4 ml-12">
      <DisplayDeliveryPlanInformation
        :deliveryPlan="props.deliveryPlan"
      />
    </v-row>
    <v-row class="text-center">
      <v-col cols="3"></v-col>
      <v-col cols="4">
        <h6>
          {{ i18n.global.t('pages.dailyReports.splitConfirmModal.leavingWarehouse') }}
        </h6>
      </v-col>
      <v-col cols="4">
        <h6>
          {{ i18n.global.t('pages.dailyReports.splitConfirmModal.returningWarehouse') }}
        </h6>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="3">
        <h6>
          {{ i18n.global.t('pages.dailyReports.splitConfirmModal.orgDeliveryPlan') }}
        </h6>
      </v-col>
      <v-col cols="4">
        {{ changeFormat(props.deliveryPlan.leaving_warehouse_date_time) }}
      </v-col>
      <v-col cols="4">
        {{ changeFormat(props.deliveryPlan.returning_warehouse_date_time) }}
      </v-col>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <v-row class="text-center">
      <v-col cols="3">
        <h6>
          {{ i18n.global.t('pages.dailyReports.splitConfirmModal.splitDeliveryPlanNo1') }}
        </h6>
      </v-col>
      <v-col cols="4">
        {{ changeFormat(props.deliveryPlan.leaving_warehouse_date_time) }}
      </v-col>
      <v-col cols="4">
        {{ changeFormat(props.splitReturningAndLeavingTime.splitReturningTime) }}
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="3">
        <h6>
          {{ i18n.global.t('pages.dailyReports.splitConfirmModal.splitDeliveryPlanNo2') }}
        </h6>
      </v-col>
      <v-col cols="4">
        {{ changeFormat(props.splitReturningAndLeavingTime.splitLeavingTime) }}
      </v-col>
      <v-col cols="4">
        {{ changeFormat(props.deliveryPlan.returning_warehouse_date_time) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-danger text-center">
        {{ i18n.global.t('pages.dailyReports.splitConfirmModal.announce') }}
      </v-col>
    </v-row>
  </div>
</template>
